const download = require("downloadjs");
const handleDownload = async (url, filename) => {
  const res = await fetch(url);
  console.log(res);
  const blob = await res.blob();
  download(blob, filename);
};

export default handleDownload;
